import { type SetItemsProps, type Item } from 'src/types'

const setItems = (dispatch: (arg0: SetItemsProps) => void, items: Record<string, Item>) => {
  dispatch({
    type: 'SET_ITEMS',
    items
  })
}

export {
  setItems
}
